import {createFileRoute} from '@tanstack/react-router';
import {AppLayout} from '@/components';
import {authGuard, can, mobileGuard} from '@/libs/router';

export const Route = createFileRoute('/_app')({
  beforeLoad: can([mobileGuard, authGuard]),
  component: AppLayout,
});
